import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { clearToken } from "../auth";

export const INACTIVITY_TIMEOUT_MS = 15 * 60 * 1000;
const CHECK_INTERVAL_MS = 30 * 1000;

const ACTIVITY_EVENTS = ["mousedown", "mousemove", "keydown", "scroll", "touchstart"] as const;

/**
 * Logs the user out (clear token + redirect to /login) after a period with no
 * mouse/keyboard/touch input. Activity events only stamp a timestamp; an
 * interval does the actual expiry check so we never churn timers on mousemove.
 */
export function useInactivityLogout(timeoutMs: number = INACTIVITY_TIMEOUT_MS) {
  const navigate = useNavigate();

  useEffect(() => {
    let lastActivity = Date.now();
    const markActivity = () => {
      lastActivity = Date.now();
    };

    // capture:true so scrolls inside nested panels count as activity too
    for (const ev of ACTIVITY_EVENTS) {
      window.addEventListener(ev, markActivity, { passive: true, capture: true });
    }

    const interval = window.setInterval(() => {
      if (Date.now() - lastActivity >= timeoutMs) {
        clearToken();
        navigate("/login");
      }
    }, CHECK_INTERVAL_MS);

    return () => {
      for (const ev of ACTIVITY_EVENTS) {
        window.removeEventListener(ev, markActivity, { capture: true });
      }
      window.clearInterval(interval);
    };
  }, [navigate, timeoutMs]);
}
